import React, { useMemo } from 'react';

import PropTypes, { bool } from 'prop-types';

import { textSort } from '../../helpers/textSort';
import SkeletonClientInfo from '../Clients/Skeleton/SkeletonClientInfo';
import PortfolioListItemComposite from './PortfolioListItemComposite';
import { useSelector } from 'react-redux';

const PortfolioListComposite = ({ list, selectedKeys, setSelectedKeys, isLoading }) => {
  console.log('🚀 ~ PortfolioListComposite ~ list:', list);
  const { portfolioList: { list: portfolioList }} = useSelector((state) => state.portfolioReducer);

  const sourceList = useMemo(() => {
    return portfolioList?.slice()?.filter?.((item) => !item.is_composite)?.sort((a, b) => textSort(a.created_at, b.created_at, -1));
  }, [portfolioList]);
  
  if (isLoading) {
    return <SkeletonClientInfo />;
  }
  return (
    <div className="portfolio-list-composite-wrapper">
    {
      sourceList?.map(item => {
        return (
          <PortfolioListItemComposite
            key={item.id}
            item={item}
            deprecated={item.status === 'ACTIVE_DEPRECATED'}
            is_locked={item.is_locked}
            selectedKeys={selectedKeys}
            setSelectedKeys={setSelectedKeys}
          />
        );
      })
    }
    </div>
  );
};

export default PortfolioListComposite;

PortfolioListComposite.propTypes = {
  list: PropTypes.array,
  selectedKeys: PropTypes.array,
  setSelectedKeys: PropTypes.func,
  isLoading: bool
};
